<template>
  <div class="VueTextToSpeech">
    <slot></slot>
  </div>
</template>

<script>
import TextToSpeechMixin from './TextToSpeechMixin';

export default {
  name: 'TextToSpeech',
  mixins: [TextToSpeechMixin],
  provide() {
    return {
      tts: this,
    };
  },
  data() {
    return {
      textToSpeech: null,
    };
  },
  props: {
    rangeBackgroundColor: {
      type: String,
      default: 'transparent',
    },
    rangeTextColor: {
      type: String,
      default: 'white',
    },
    wordBackgroundColor: {
      type: String,
      default: 'transparent',
    },
    wordTextColor: {
      type: String,
      default: 'white',
    },
    languageCode: {
      type: String,
    },
  },
  async mounted() {
    this.textToSpeech = await this.onLoadTextToSpeech();

    this.textToSpeech.View.init({
      config: {
        range_background_color: this.rangeBackgroundColor,
        range_text_color: this.rangeTextColor,
        word_background_color: this.wordBackgroundColor,
        word_text_color: this.wordTextColor,
      },
    }).done(() => {
      this.textToSpeech.View.setVoice({
        language_code:
          this.languageCode || this.helpers.utils.getCurrentLanguage(),
      });

      this.textToSpeech.View.on('play', () => {
        this.$emit('on-play');
      });

      this.textToSpeech.View.on('speech:complete', () => {
        this.$emit('on-complete');
      });
    });
  },
  methods: {
    stop() {
      if (this.textToSpeech) {
        if (this.textToSpeech.View) {
          this.textToSpeech.View.stop();
        }
      }
    },
  },
};
</script>

<style scoped></style>
